import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography';

import classes from './OfferOptions.scss';

export default function OfferOption({ tooltip, title, value, suffix, name, dense }) {
  return (
    <div className={classNames(classes.offerOption, {
      [classes.offerOption__dense]: dense,
    })}>
      <div className={classes.offerOption__title}>
        {tooltip ?
          (
            <Tooltip
              title={tooltip}
              classes={{
                popper: classes.offerOption__tooltip,
                tooltip: classes.offerOption__tooltipContent
              }}
            >
              <Typography component="span" color="textSecondary">{title}</Typography>
            </Tooltip>
          ) : (
            <Typography component="span" color="textSecondary">{title}</Typography>
          )
        }
      </div>
      {dense && (
        <div className={classes.offerOption__points}></div>
      )}
      <Typography
        component="div"
        className={classNames(classes.offerOption__value, {
          [classes.offerOption__value__dense]: dense
        })}
        data-offeroption-value={name}
        color="textPrimary"
      >
        {value} {suffix}
      </Typography>
    </div>
  );
}

OfferOption.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  suffix: PropTypes.string,
  tooltip: PropTypes.string,
  dense: PropTypes.bool
}
